import { Grid } from '@calendly/ui/components/grid';
import classNames from 'classnames';
import { forwardRef } from 'react';
const certificateLabelCss = "c1rvxun9";
export const CertificateLabel = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(certificateLabelCss, props.className)} />;
});
const copyTextCss = "cqododk";
export const CopyText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(copyTextCss, props.className)} />;
});
const enforcementSubtitleCss = "eh9bwuw";
export const EnforcementSubtitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(enforcementSubtitleCss, props.className)} />;
});
const helpTextCss = "h2x2ayn";
export const HelpText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(helpTextCss, props.className)} />;
});
const hintCss = "hxfi1ql";
export const Hint = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(hintCss, props.className)} />;
});
const justifiedGridCss = "jr68odm";
export const JustifiedGrid = forwardRef((props, ref) => <Grid ref={ref} {...props} className={classNames(justifiedGridCss, props.className)} />);
const rowCss = "r1unkqaz";
export const Row = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(rowCss, props.className)} />;
});
const sectionCss = "s1hqcmrg";
export const Section = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(sectionCss, props.className)} />;
});
const subTitleCss = "sphg3xq";
export const SubTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subTitleCss, props.className)} />;
});

require("./styles.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./styles.js");